export class TimeoutError extends Error {
  constructor(durationMs: number, message?: string) {
    super(
      message ?? `The operation timed out after ${durationMs} milliseconds.`,
    );
    this.name = 'TimeoutError';
  }
}
